module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"message":{"title_job":"学校の承認後、求人情報が閲覧できます。","title_seminar":"学校の承認後、説明会情報が閲覧できます。","title_internship":"学校の承認後、企業実習情報が閲覧できます。","message1":"しばらく経っても、学校から承認がされない場合は直接学校へお問い合わせください。\\nアカウント作成日：{createdAt}","message2":"承認後、すぐに就職活動ができるよう、プロフィール内の情報を充実させましょう！","my_page":"マイページへ"}}}')
  delete Component.options._Ctor
}
